import { Analytics } from "@/shared/utils/analytics/analytics";
import { BettingMode } from "../betting-mode";
import { AnalyticsError } from "./analytics-error";

/* eslint-disable @typescript-eslint/prefer-as-const */
export class AnalyticsPage {
    type: string;
    kind: string;
    error?: AnalyticsError;
    checkout: Record<any, any>;
    tutorial?: boolean;
    private verticalCode: "loterie" = "loterie" as const;
    private verticalCodeStrict: "loterie" = this.verticalCode;
    private gameCode = Analytics.lotteryCode();
    private gameCodeStrict: string;
    private bettingMode: BettingMode;

    constructor(
        type: "game.detail" | "checkout" | "error" | "purchase",
        error: AnalyticsError = null,
        kind: string = null,
        checkout: Record<any, any> = null,
        gameCodeStrict: string = Analytics.lotteryCode(),
        bettingMode: BettingMode = null
    ) {
        if (this.type == "purchase" && window.kasickaBetType == "tutorial") this.tutorial = true;
        this.type = type;
        this.kind = kind;
        if (error) this.error = error;
        this.checkout = checkout;
        this.gameCodeStrict = gameCodeStrict;
        this.bettingMode = bettingMode;
    }
}
